import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComputerUse: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconComputerUse"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 17L12.5 12.5L17 11L8 8L11 17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconComputerUse;
